import './Testimonials.css';

function Testimonials() {
  const testimonials = [
    {
      name: 'Anthony Carter',
      location: 'Nashville, TN',
      text: 'RoofPro Expert LLC made the whole process way easier than we expected. They showed up when they said they would, explained everything clearly, and did solid work. The crew was respectful, and the cleanup was thorough. We’re really happy with how the roof turned out.',
      rating: 5
    },
    {
      name: 'Daniel Brooks',
      location: 'Brentwood, TN',
      text: 'We had a great experience with RoofPro Expert LLC. They were honest about what needed to be done and didn’t try to upsell us. The work was completed on time, and the roof looks great. I’d definitely recommend them to anyone needing roofing work.',
      rating: 4.5
    },
    {
      name: 'James Holloway',
      location: 'Franklin, TN',
      text: 'It’s hard to find contractors you can trust, but RoofPro Expert LLC came through. Communication was clear, the pricing was fair, and the work was done right the first time. No stress, no surprises. Just good service.',
      rating: 5
    }
  ];

  return (
    <div className="testimonials-section">
      <div className="container">
        <h2>What Our Customers Say</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="rating">
                {'★'.repeat(testimonial.rating)}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <strong>{testimonial.name}</strong>
                <span>{testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
